<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12 pb-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-text="$t('PrivacyStatement.Content.Title')" />
        <p class="ota-body-light" v-html="$t('PrivacyStatement.Content.Description')" />
      </div>
      <PrivacyStatementComponent />
    </div>
  </div>
</template>

<script>
import PrivacyStatementComponent from '@/components/PrivacyStatementComponent'

export default {
  name: 'PrivacyStatementPage',
  layout: 'homepage',
  components: {
    PrivacyStatementComponent
  },
  head () {
    return {
      title: this.$t('PrivacyStatement.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('PrivacyStatement.Description')
        }
      ]
    }
  }
}
</script>
